<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">Transporter Utilization Report</div>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
                            <label class="col-2">{{ $t("stuffing_date") }}</label>
                            <DatePicker dateFormat="dd/mm/yy" v-model="header.Stuffing_Date_From" class="col-4" />
                            <label class="col-1">To</label>
                            <DatePicker dateFormat="dd/mm/yy" v-model="header.Stuffing_Date_To" class="col-4" />
                        </div>
                        <div class="col-12">
                            <FormField fieldName="Transporter_Code" :labelName="$t('transporter')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Transporter_Code"
                                    :url="this.$API_URL + 'list/transporter_all'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Loading_Destination_From" :labelName="$t('loading')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Loading_Destination_From" optionValue="nama"
                                    :url="this.$API_URL + 'list/location'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Loading_Destination_To" :labelName="$t('destination')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Loading_Destination_To" optionValue="nama"
                                    :url="this.$API_URL + 'list/location'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Order_Type_Code" :labelName="$t('order_type')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Order_Type_Code"
                                    :url="this.$API_URL + 'list/order_type_code'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Document_Type" :labelName="$t('doc_type')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Document_Type" :url="this.$API_URL + 'list/lookup'"
                                    :params="{group: this.$LOOKUP_GROUP.DOCUMENT_TYPE}" />
                            </FormField>

                            <FormField fieldName="Distribution" :labelName="$t('distribution')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Distribution" :url="this.$API_URL + 'list/lookup'"
                                    :params="{group: this.$LOOKUP_GROUP.DISTRIBUTION}" />
                            </FormField>

                            <FormField fieldName="Business_Segment_Code" :labelName="$t('product_category')"
                                v-model="header" fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Business_Segment_Code"
                                    :url="this.$API_URL + 'list/business_segment_code'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Order_Type_Id" :labelName="$t('commodity')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Commodity"
                                    :url="this.$API_URL + 'list/commodity_group'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Material_Code" :labelName="$t('material')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Material_Code"
                                    :url="this.$API_URL + 'list/material_all'" :params="{}" />
                            </FormField>

                            <FormField fieldName="Shipment_Type" :labelName="$t('shipment_type')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomMultiSelect v-model="header.Shipment_Type" :url="this.$API_URL + 'list/lookup'"
                                    :params="{group: this.$LOOKUP_GROUP.SHIPMENT_TYPE}" />
                            </FormField>

                            <FormField fieldName="Warehouse_Code" :labelName="$t('warehouse')" v-model="header"
                                fieldClass="col-6" labelClass="col-2">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Warehouse_Code"
                                    :url="this.$API_URL + 'list/warehouse'" :minLength="0" :params="{}"
                                    :filter="true" />
                            </FormField>

                            <FormField fieldName="Show_Sub_Total" labelName="Show Sub Total" v-model="header" fieldClass="col-6"
                                labelClass="col-2">
                                <Dropdown v-model="header.Show_Sub_Total" class="p-inputtext-sm" :options="showSubTotal"
                                    optionLabel="label" optionValue="value" />
                            </FormField>

                        </div>
                    </div>
                </div>
                <Button type="button" label="Generate" @click="getReport()" />
                &nbsp;
                <Button type="button" class="p-button-success" label="Reopen" @click="reopenTab()" v-show="this.reportTbl"/>
            </template>
        </Card>
    </form>

    <ShowReport
    :title="title"
    :isVisible="showReport"
    :reportTbl="this.reportTbl"
    @close="resetBtn()"
    />

</template>

<script>
    import ShowReport from "../Report/ShowReport.vue";
    import FormField from "../Helper/FormField.vue";
    export default {
        components: {
            ShowReport,
            FormField
        },
        data() {
            name: "TransporterUtilizationReport";
            return {
                url: this.$API_URL + "report/",
                reportTbl: null,
                showReport:false,
                showSubTotal: [
                    {label: "Y", value: "Y"},
                    {label: "N", value: "N"}
                ],
                header: {
                    Stuffing_Date_From: null,
                    Stuffing_Date_To: null,
                    Transporter_Code: [],
                    Loading_Destination_From: [],
                    Loading_Destination_To: [],
                    Order_Type_Code: [],
                    Document_Type: [],
                    Distribution: [],
                    Business_Segment_Code: [],
                    Commodity: [],
                    Material_Code: [],
                    Shipment_Type: [],
                    Warehouse_Code: null,
                    Show_Sub_Total: "N"
                }
            }
        },
        methods: {
            reopenTab(){
                this.showReport=true
            },
            resetBtn() {
                this.showReport = false;
            },
            getReport() {
                var self = this;
                // console.log(self.header)
                // return;
                this.$emit("blockBody");

                if(self.header.Stuffing_Date_From == null){
                    this.showError("Validation error", "Stuffing Date From is required.");
                    return;
                }

                this.$axios.post(self.url+ "generate_transporter_Utilization", self.header)
                .then((response) => {
                    if(response.data.success){
                        this.reportTbl = {
                            header:response.data.data.header,
                            content:response.data.data.content,
                            title:response.data.data.title
                        }
                        this.showReport = true;
                    }else{
                        this.showError("Generate Report Error", response.data.message);
                    }
                    this.$emit("unblockBody");
                })
                .catch((exc) => {
                    this.$emit("unblockBody");
                })
            },
            closeReport() {
                this.showReport = false;
            },
            showError(summary, message) {
                this.$emit('unblockBody');
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
        }
    }
</script>